import React, { useContext, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import MDSelectBox from "components/MDSelectBox";
import { validationSchema } from "./schemas/validation";
import { initialValues } from "./schemas/initialValue";
import { addCommittee } from "Apis/committees";
import { updateCommittee } from "Apis/committees";
import { CommitteeContext } from "context/CommitteeContext";
import { statusData } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import MDInput from "components/MDInput";
import MDTextField from "components/MDTextField";

const CommitteeForm = ({ committeeData }) => {
  const { setNotification } = useContext(LoginFormContext);
  const { editData, setEditData, handleCommitteeList, jsonListing } = useContext(CommitteeContext);
  // const { parentMemberList, parentDataListing } = useContext(MemberContext);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const { setOpen, formIsEdit } = useContext(ModalContext);
  // const [parentMember, setParentMember] = useState(null);

  // const getMemberLabel = (id) => {
  //   const memberLabel = parentMemberList.find((item) => item.value === id);
  //   return memberLabel ? memberLabel.label : "-";
  // };

  const handleSubmit = async (values) => {
    if (!formIsEdit) {
      let response = await addCommittee(values);
      if (response?.status === 200) {
        committeeData();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      let editData = await updateCommittee(values);
      if (editData?.status === 200) {
        handleCommitteeList();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: editData.data.message,
          open: true,
        });
        setOpen(false);
        committeeData();
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: editData.data.message,
          open: true,
        });
      }
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const formik = useFormik({
    initialValues: formIsEdit ? setEditData : initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  // const handleMember = async (data) => {
  //   formik.setFieldValue("member_id", data?.value);
  //   setParentMember(data?.label);
  // };

  // set data in formik
  const setDataInFormik = async () => {
    formik.setValues(editData);
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  useEffect(() => {
    jsonListing();
    handleCommitteeList();
    // parentDataListing();
    if (formIsEdit) {
      setDataInFormik();
      // setParentMember(
      //   editData?.member_id
      //     ? {
      //         label: getMemberLabel(editData?.member_id),
      //         value: editData?.member_id,
      //       }
      //     : null
      // );
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    }
  }, []);

  return (
    <MDBox>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: "10px !important" }}>
            <MDInput
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Full Name"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.name && formik.errors.name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.name}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} sm={6} sx={{ paddingTop: "10px !important" }}>
            <MDInput
              type="text"
              name="contact_details"
              value={formik.values.contact_details}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Contact Details"
              sx={{ width: "100%" }}
              variant="standard"
            />
            {formik.touched.contact_details && formik.errors.contact_details && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.contact_details}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={12} sx={{ paddingTop: "10px !important" }}>
            <MDTextField
              type="text"
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Address"
              variant="standard"
              multiline
              rows={4}
            />
            {formik.touched.address && formik.errors.address && (
              <Box sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.address}
              </Box>
            )}
          </Grid>
          <Grid item xs={12} md={12} sx={{ paddingTop: "10px !important" }}>
            <MDTextField
              type="text"
              name="extra_information"
              value={formik.values.extra_information}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Extra Information"
              variant="standard"
              multiline
              rows={4}
            />
            {formik.touched.extra_information && formik.errors.extra_information && (
              <Box sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.extra_information}
              </Box>
            )}
          </Grid>

          {/* <Grid item xs={12} md={6} sx={{ paddingTop: "10px !important" }}>
            <MDSelectBox
              name="member_id"
              defaultValue={parentMember}
              options={parentMemberList}
              handleChange={(value) => handleMember(value)}
              label="Head Member"
              width="100%"
              isImage={true}
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.member_id && formik.errors.member_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.member_id}
              </MDBox>
            )}
          </Grid> */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "25px !important" }}>
            <MDTextField
              type="number"
              name="sort_order"
              value={formik.values.sort_order}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Sort Order"
              variant="standard"
            />
            {formik.touched.sort_order && formik.errors.sort_order && (
              <Box sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.sort_order}
              </Box>
            )}
          </Grid>
          {/* status */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "25px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </MDBox>
  );
};
CommitteeForm.propTypes = {
  committeeData: PropTypes.func,
};
export default CommitteeForm;
